import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import React, { useState } from 'react';
import socketService from '../../helpers/utils/socketService';

const AlertMessage = () => {
  const [content, setContent] = useState('');
  const [severityType, setSeverityType] = useState('success');

  const handleMessageChange = (event) => {
    setContent(event.target.value);
  };

  const handleSeverityTypeChange = (event) => {
    setSeverityType(event.target.value);
  };

  const handleSendAlert = () => {
    if (content) {
      socketService.emit('sendAlert', { content, severityType });
      setContent(''); // Clear input after sending
    }
  };

  return (
    <div>
      <FormControl fullWidth margin="normal">
        <TextField
          label="Enter your content"
          variant="outlined"
          value={content}
          onChange={handleMessageChange}
          fullWidth
        />
      </FormControl>

      <FormControl fullWidth margin="normal">
        <InputLabel>SeverityType</InputLabel>
        <Select
          value={severityType}
          onChange={handleSeverityTypeChange}
          label="SeverityType"
        >
          <MenuItem value="success">Success</MenuItem>
          <MenuItem value="info">Info</MenuItem>
          <MenuItem value="warning">Warning</MenuItem>
          <MenuItem value="error">Error</MenuItem>
        </Select>
      </FormControl>

      <Button variant="contained" color="primary" onClick={handleSendAlert}>
        Send Alert
      </Button>
    </div>
  );
};

export default AlertMessage;
